// Generated by Dev AI Agent.
// zone.js AbortSignal compatibility shim (BSS-27319).
//
// intl-tel-input binds its per-open dropdown listeners with an AbortSignal and
// removes them by aborting that signal on close. zone.js 0.11.x (shipped with
// Angular 12) mishandles the `signal` listener option: once a signal-bound
// listener is aborted, the (element, eventType) pair is left in a corrupted
// state and no further listener of that type can be added to that element. That
// kills the country dropdown on its second open and, on shared targets
// (document / documentElement), poisons those event types for the whole app.
//
// The fix routes only signal-bearing listeners to the native, un-patched
// addEventListener so the browser handles the AbortSignal itself. zone.js keeps
// full control of every other listener (Angular change detection is driven by
// listeners that do not pass a signal), so the rest of the app is unaffected.

let applied = false;

export function ensureZoneSignalCompat(): void {
  if (applied) {
    return;
  }
  applied = true;

  const zone: any = (window as any).Zone;
  if (!zone || typeof zone.__symbol__ !== 'function') {
    return;
  }

  const proto: any = EventTarget.prototype;
  if (proto.__phoneSignalCompat) {
    return;
  }

  const nativeAdd: any = proto[zone.__symbol__('addEventListener')];
  if (typeof nativeAdd !== 'function') {
    return;
  }

  const patchedAdd: any = proto.addEventListener;
  proto.addEventListener = function (type: string, listener: any, options: any): void {
    if (options && typeof options === 'object' && options.signal) {
      nativeAdd.call(this, type, listener, options);
      return;
    }
    patchedAdd.call(this, type, listener, options);
  };
  proto.__phoneSignalCompat = true;
}
